import { useEffect, useState } from "react";
import api, { fmtErr } from "../api";
import { toast } from "sonner";
import { X } from "@phosphor-icons/react";

export const QuoteView = ({ jobId, onClose, testid = "quote-view" }) => {
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    api.get(`/jobs/${jobId}/quote`).then((r) => setDoc(r.data)).catch((e) => toast.error(fmtErr(e)));
  }, [jobId]);

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-background" data-testid={testid}>
      <div className="flex items-center justify-between gap-3 border-b border-border p-4">
        <p className="min-w-0 truncate font-heading text-sm font-bold" data-testid={`${testid}-title`}>
          {doc ? (doc.sent_at ? `Quote as sent${doc.sent_to ? ` · ${doc.sent_to}` : ""}` : "Quote preview — not sent yet") : "Loading…"}
        </p>
        <button data-testid={`${testid}-close`} onClick={onClose} className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-border">
          <X size={18} weight="bold" />
        </button>
      </div>
      {doc && <iframe title="Quote document" srcDoc={doc.html} className="w-full flex-1 bg-white" data-testid={`${testid}-frame`} />}
    </div>
  );
};
